<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-8">
              <h3 class="mb-0 view-header-buttons">
                <span class="text-before-button">{{
                  resellerProduct.name
                }}</span>
                <base-button
                  v-if="
                    $currentUserCan($permissions.PERM_EDIT_RESELLER_PRODUCTS)
                  "
                  type="primary"
                  icon
                  size="sm"
                  @click="editResellerProduct()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-edit"></i>
                  </span>
                </base-button>

                <base-button
                  v-if="
                    $currentUserCan($permissions.PERM_DELETE_RESELLER_PRODUCTS)
                  "
                  type="danger"
                  icon
                  size="sm"
                  @click="deleteResellerProduct()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-trash"></i>
                  </span>
                </base-button>
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack()"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>

              <notification-subscription
                :objectType="'reseller-products'"
                :objectId="resellerProduct.id"
                :events="{
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
            </div>
          </div>
        </template>
        <div>
          <div
            class="col-12 justify-content-center justify-content-sm-between flex-wrap tabs-wrapper"
          >
            <tabs
              fill
              class="flex-column flex-md-row"
              tabNavWrapperClasses="nav-wrapper"
              tabNavClasses="nav nav-pills nav-fill"
              value="global"
            >
              <card shadow>
                <tab-pane title="global" id="1" :active="true">
                  <span slot="title">
                    <i class="ni ni-cloud-upload-96" />
                    {{ $t("COMMON.GLOBAL") }}
                  </span>
                  <reseller-product-view-global
                    :resellerProduct="resellerProduct"
                  />
                </tab-pane>

                <tab-pane title="gallery" id="2">
                  <span slot="title">
                    <i class="ni ni-cloud-upload-96" />
                    {{ $t("COMMON.GALLERY") }}
                  </span>
                  <reseller-product-view-gallery
                    :resellerProduct="resellerProduct"
                  />
                </tab-pane>

                <tab-pane
                  title="logs"
                  id="999"
                  v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
                >
                  <span slot="title">
                    <i class="fa fa-file" />
                    {{ $t("COMMON.LOGS") }}
                  </span>
                  <resellerProduct-view-logs
                    :resellerProduct="resellerProduct"
                  />
                </tab-pane>
              </card>
            </tabs>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { cloneDeep } from "lodash";
import swal from "sweetalert2";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { Tabs, TabPane } from "@/components";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import defaultResellerProduct from "./defaultResellerProduct";
import ResellerProductViewGlobal from "./partials/ResellerProductViewGlobal.vue";
import ResellerProductViewLogs from "./partials/ResellerProductViewLogs.vue";
import ResellerProductViewGallery from "./partials/ResellerProductViewGallery.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    ResellerProductViewGlobal,
    ResellerProductViewGallery,
    ResellerProductViewLogs,
    NotificationSubscription,
  },

  mixins: [requestErrorMixin],

  data() {
    return {
      resellerProduct: cloneDeep(defaultResellerProduct),
    };
  },

  computed: {},

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("resellerProducts/get", id);
        this.resellerProduct =
          this.$store.getters["resellerProducts/resellerProduct"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async editResellerProduct() {
      this.$router.push({
        name: "Edit ResellerProduct",
        params: { id: this.resellerProduct.id },
      });
    },

    async deleteResellerProduct() {
      const confirmation = await swal.fire({
        title: this.$t("RESELLER_PRODUCTS.DELETE_THIS_RESELLER_PRODUCT"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch(
            "resellerProducts/destroy",
            this.resellerProduct.id
          );
          await this.goBack();
          this.$notify({
            type: "success",
            message: this.$t("RESELLER_PRODUCTS.RESELLER_PRODUCT_DELETED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    goBack() {
      this.$router.push({ name: "List ResellerProducts" });
    },
  },
};
</script>
